import { sha256 as sha256Implementation } from 'js-sha256';

/**
 * Hashes the input string using SHA-256 and returns the result.
 * @param input
 */
export const sha256 = (input: string): string => {
  return sha256Implementation(input);
};
